import { render } from "./SubscriptionPayment.vue?vue&type=template&id=210d8e1b"
import script from "./SubscriptionPayment.vue?vue&type=script&lang=js"
export * from "./SubscriptionPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__